import { render, staticRenderFns } from "./off-duty-detection.vue?vue&type=template&id=c95ef61a&scoped=true&"
import script from "./off-duty-detection.vue?vue&type=script&lang=ts&"
export * from "./off-duty-detection.vue?vue&type=script&lang=ts&"
import style0 from "./off-duty-detection.vue?vue&type=style&index=0&id=c95ef61a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c95ef61a",
  null
  
)

export default component.exports